import Vue from 'vue'
import App from './jobs-detail.vue'
import "@/common/config/init"

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
